import React from 'react'
import classNames from 'classnames'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import programStyles from '../programStyles.module.scss'

const EventTypeChip = ({ eventCardType, color }) => (
  <div
    className={classNames(
      programStyles.eventTypeChip,
      generalStyles.mr20,
      programStyles[color]
    )}
    data-testid="eventCardType"
  >
    <span
      className={
        color === 'white'
          ? fontStyles.pxsmallboldlsssin08blackgraphik12pt
          : fontStyles.pxsmallboldlsssin01whitegraphik12pt
      }
      style={{
        textTransform: 'capitalize',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row'
      }}
    >
      {eventCardType}
    </span>
  </div>
)

export default EventTypeChip
